import React from "react";
import Button from "@mui/material/Button";
import { styled } from "@mui/material/styles";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": {
    padding: theme.spacing(3),
    paddingTop: theme.spacing(0),
  },
  "& .MuiDialog-paper": {
    borderRadius: "var(--dialog-border-radius)",
  },
}));

export default function SaveCardCreditPopup({
  isOpen,
  setIsOpen,
  headerText,
  bodyText,
  confirmText,
  cancelText,
  handleConfirm,
  handleCancel,
}) {
  const handleClose = () => {
    setIsOpen(false);
  };
  return (
    <BootstrapDialog
      onClose={handleClose}
      aria-labelledby="customized-dialog-title"
      open={isOpen}
      sx={{
        p: 0,
        // maxWidth: "320px"
      }}
      maxWidth={"lg"}
      fullWidth={true}
    >
      <Box>
        <Box>
          <DialogTitle
            sx={{
              m: 0,
              px: 3,
              pt: 3,
              textAlign: "end",
              color: "var(--darkblue)",
              fontWeight: 700,
              fontSize: "24px",
              fontFamily: `var(--font-family) !important`,
              display: "flex",
              justifyContent: "flex-end",
            }}
            id="customized-dialog-title"
          >
            <p style={{ width: "150px", lineHeight: "28px" }}>{headerText}</p>
          </DialogTitle>
        </Box>
        <DialogContent
          sx={{
            direction: "rtl",
            display: "flex",
            flexDirection: "column",
          }}
        >
          <Typography
            gutterBottom
            sx={{
              lineHeight: "24px",
              fontSize: "16px",
              fontFamily: `var(--font-family) !important`,
              textAlign: "right",
              mb: "59px",
              color: "#565656",
            }}
          >
            {bodyText}
          </Typography>
        </DialogContent>
        <DialogActions sx={{ p: 0 }}>
          <Button
            variant="contained"
            className="phone-dialog-btn phone-dialog-darkblue-btn w-100-percents"
            onClick={() => handleConfirm()}
            sx={{
              height: "58px",
              fontFamily: `var(--font-family) !important`,
              fontWeight: 700,
            }}
          >
            {confirmText}
          </Button>
          <Button
            variant="contained"
            onClick={() => handleCancel()}
            className="phone-dialog-btn phone-dialog-red-btn w-100-percents"
            sx={{
              height: "58px",
              fontFamily: `var(--font-family) !important`,
              fontWeight: 700,
            }}
          >
            {cancelText}
          </Button>
        </DialogActions>
      </Box>
    </BootstrapDialog>
  );
}
